module.exports = __webpack_public_path__ + "assets/img/swiper-img5-6f9335d7.png";